<template>
  <div class="d-flex date-time-picker">
    <div>
      <v-row>
        <v-col cols="12" md="12">
          <div class="date-picker__wrapper">
            <v-date-picker
              v-model="selectedDate"
              :allowed-dates="allowedDates"
              full-width
              class="mt-4"
              :min="minDate"
              :max="maxDate"
              color="primary"
              header-color="primary"
              :events="eventsArray"
              event-color="primary"
              :first-day-of-week="1"
            ></v-date-picker>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="slots__wrapper">
      <v-row v-for="(item, index) in psychologistInfo" :key="index" :class="{
                'invisible': convertDate(item.date.value) != selectedDate,
              }">
        <v-col cols="12" md="12">
          <span>{{ item.date.translated }}</span>
          <div class="d-flex flex-wrap timePicker">
            <v-btn
              v-for="(slot, i) in item.slots"
              :key="slot.id"
              :data-slot-id="slot.id"
              @click="dataToEmit({ slot, date: item.date }, i, $event, item.slots)"
              class="ml-2 mt-2 btn-disable"
              outlined
              :class="{
                'btn-current': slot.is_booked_by_current_user,
              }"
              :disabled="slotType == 1? isDisabledSlot(item.slots, i) : isDisabledSlot(item.slots, i) || isDisabledSlot(item.slots, i + 1)"
            >
              {{ slot.time }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "showDateTimePicker",
  data() {
    return {
      selectedDate: null,
      multiSelected: [],
      prevBtn: null,
      prevSecondBtn: null,
      patientName: "Господин",
      psychologistInfo: [],
      resheduleSessionAvailable: true,
      activeSlot: null,
      selectedSlot: null,
      nextSlotAvailable: false,
      selectedSecondSlot: null,
      selectedSlotBtn: null,
      nextSessionInfoAproved: false,
      nextSessionInfo: {
        sessionDay: "Вторник",
        sessionTime: "18:00",
        sessionDate: "21.01.22",
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.selectedDate = this.minDate;
      this.emitSelectedDate();
      this.emitSelectedSlot();
    });
  },
  props: {
    selectCalendarId: {
      type: String,
      required: false,
      default: null,
    },
    isMultiSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    handleUserSelectData: {
      type: Function,
      required: false,
      default: () => function () {},
    },
    defaultValue: {
      type: Object,
      required: false,
      default: () => {},
    },
    slotType: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  computed: {
    allowedDatesArray() {
      let array = [];
      this.psychologistInfo.forEach((el) => {
        let hasActiveSlots = false;
        el.slots.forEach((slot, i) => {
          if (this.slotType == 1? !this.isDisabledSlot(el.slots, i) : !this.isDisabledSlot(el.slots, i) && !this.isDisabledSlot(el.slots, i + 1)) {
            hasActiveSlots = true; 
          }
        });

        if (hasActiveSlots) {
          array.push(this.convertDate(el.date.value));
        }
      });
      return array;
    },
    eventsArray() {
      let array = [];
      this.psychologistInfo.forEach((el) => {
        let hasBookedSlots = false;
        el.slots.forEach((slot) => {
          if (slot.is_booked_by_current_user) {
            hasBookedSlots = true; 
          }
        });

        if (hasBookedSlots) {
          array.push(this.convertDate(el.date.value));
        }
      });
      return array;
    },
    minDate() {
      return this.allowedDatesArray.length
        ? this.allowedDatesArray.reduce((a, b) => a < b ? a : b)
        : null;
    },
    maxDate() {
      return this.allowedDatesArray.length
        ? this.allowedDatesArray.reduce((a, b) => a > b ? a : b)
        : null;
    },
    /* selectedDatesArray() {
      let array = [];
      this.psychologistInfo.forEach((el) => {
        let convertedDate = this.convertDate(el.date.value);
        if(this.selectedDate === convertedDate) {
          array.push(el);
        }
      });
      return array;
    }, */
  },
  watch: {
    slotType () {
      if (this.nextSlotDisabled && this.slotType == 2) {
        this.nextSlotDisabled = false;
        this.$emit("userSelect", null);
        this.selectedSlot = null;

        if (this.prevBtn) {
          this.prevBtn.classList.remove("active");
        }
        this.prevBtn = null;

        if (this.prevSecondBtn) {
          this.prevSecondBtn.classList.remove("active");
        }
        this.prevSecondBtn = null;
        
        this.saveTimeSlotToProps(null);

        this.$nextTick(() => {
          this.emitSelectedSlot();
        });
      }
    },
    defaultValue () {
      this.$emit("userSelect", null);
      this.selectedSlot = null;

      if (this.prevBtn) {
        this.prevBtn.classList.remove("active");
      }
      this.prevBtn = null;

      if (this.prevSecondBtn) {
        this.prevSecondBtn.classList.remove("active");
      }
      this.prevSecondBtn = null;
      
      this.saveTimeSlotToProps(null);

      this.psychologistInfo = this.defaultValue.time_slots;

      this.$nextTick(() => {
        this.emitSelectedDate();
        this.emitSelectedSlot();
      });
    },
  },
  methods: {
    convertDate(val) {
      const [day, month, year] = val.trim().split('.');
      return `${year}-${month.padStart(2,'0')}-${day.padStart(2,'0')}`;
    },
    allowedDates(val) {
      return this.allowedDatesArray.includes(val);
    },

    getItemWithSlot() {
      const item = this.psychologistInfo.find(i =>
        i.slots.some(slot => slot.id === this.selectCalendarId)
      );
      if (!item) return false;
      return item;
    },
    emitSelectedDate() {
      let item = this.getItemWithSlot();
      if (!item) return;

      this.selectedDate = this.convertDate(item.date.value);
    },
    emitSelectedSlot() {
      let item = this.getItemWithSlot();
      if (!item) return;

      const index = item.slots.findIndex(slot => slot.id === this.selectCalendarId);

      const isDisabled = this.slotType == 1
        ? this.isDisabledSlot(item.slots, index)
        : this.isDisabledSlot(item.slots, index) || this.isDisabledSlot(item.slots, index + 1);
      if (isDisabled) return;

      const slot = item.slots[index];

      this.$nextTick(() => {
        const btn = this.$el.querySelector(`[data-slot-id="${this.selectCalendarId}"]`);
        if (!btn) return;

        const fakeEvent = new Event('click', { bubbles: true });
        Object.defineProperty(fakeEvent, 'target', { value: btn });

        this.dataToEmit({ slot, date: item.date }, index, fakeEvent, item.slots);
      });
    },
    isDisabledSlot(slots, i) {
      if (slots[i]) {
        return slots[i].is_booked_by_current_user ? false : slots[i].is_booked || !slots[i].available;
      }

      return true;
    },
    resheduleSession() {
      this.nextSessionInfoAproved = false;
    },
    cancelResheduleSession() {
      this.nextSessionInfoAproved = true;
    },
    dataToEmit(selectedTimeSlot, i, event, slots) {
      this.selectedSlot = selectedTimeSlot;
      this.activeSlot = i;
      this.nextSlotDisabled = this.isDisabledSlot(slots, i + 1);

      if (this.isMultiSelect) {
        if (
          this.multiSelected.find(
            (el) => el.slot.id === selectedTimeSlot.slot.id
          )
        ) {
          this.multiSelected = this.multiSelected.filter(
            (el) => el.slot.id !== selectedTimeSlot.slot.id
          );
        } else {
          this.multiSelected.push(selectedTimeSlot);
        }
      } else {
        if (this.prevBtn) {
          this.prevBtn.classList.remove("active");
        }
        if (this.prevSecondBtn) {
          this.prevSecondBtn.classList.remove("active");
        }
        this.$emit("userSelect", this.selectedSlot);
      }

      this.saveTimeSlotToProps(selectedTimeSlot);

      if (event.target.tagName === "SPAN") {
        this.prevBtn = event.target.parentElement;
        event.target.parentElement.classList.toggle("active");
        /* if (this.slotType !== 1) {
          this.prevSecondBtn = this.prevBtn.nextElementSibling;
          this.prevSecondBtn.classList.toggle("active");
        } */
      } else {
        this.prevBtn = event.target;
        event.target.classList.toggle("active");
        /* if (this.slotType !== 1) {
          this.prevSecondBtn = this.prevBtn.nextElementSibling;
          this.prevSecondBtn.classList.toggle("active");
        } */
      }
    },
    saveTimeSlotToProps(selectedTimeSlot) {
      let psychologist = {
        name: this.defaultValue.name,
        id: this.defaultValue.id,
        timeSlot: selectedTimeSlot ? {
          ...selectedTimeSlot,
        } : {},
      };

      this.handleUserSelectData(psychologist);
    },
  },
  beforeMount() {
    this.psychologistInfo = this.defaultValue.time_slots;
    // this.defaultValue.time_slots

    // this.psychologistInfo.availableTimeSlots.map((el) => {
    //   el.slots.map((item) => {
    //     item.isDisable
    //       ? this.multiSelected.push({ slot: item, date: el.date })
    //       : [];
    //   });
    // });
  },
};
</script>

<style scoped>
.date-time-picker {
  flex-wrap: wrap;
  column-gap: 30px;
}

@media screen and (max-width: 1263px) {
  .date-time-picker {
    flex-wrap: wrap;
    column-gap: 16px;
  }
}

.slots__wrapper {
  flex-basis: 370px;
  flex-grow: 1;
}

.invisible {
  overflow: hidden;
  height: 0px;
}

.date-picker__wrapper {
  max-width: 320px;
  /* max-width: 100%; */
}

.date-picker__wrapper ::v-deep(.v-picker__title) {
  padding: 8px 12px;
}

.date-picker__wrapper ::v-deep(.v-date-picker-title__date) {
  font-size: 18px;
}

.date-picker__wrapper ::v-deep(.v-date-picker-title__year) {
  margin-bottom: 1px;
}

.timePicker {
  width: 100%;
}

.btn-disable {
  width: 84px;
  color: #59b6b9;
}
.timePicker .btn-disable.btn-current {
  color: #ffffff !important;
  background-color: #00a3b6;
}

/* .active {
  color: #ffffff !important;
  background-color: #00a3b7 !important;
} */
.active {
  color: #ffffff !important;
  background: repeating-linear-gradient(
    -60deg,
    #00a3b6,
    #00a3b6 10px,
    #008192 10px,
    #008192 20px
  );
  border: 1px solid #00a3b6;
}
.theme--light.v-btn.v-btn--disabled.active {
  color: #ffffff !important;
  background-color: rgba(0, 0, 0, 0.26) !important;
}
</style>
